import React from 'react'

import { TagComponent } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { array } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function Categories({ list = EMPTY_ARRAY }) {
  function getColors(slug) {
    // TODO: add more when available
    switch (slug) {
      case 'interviews':
        return { backColor: 'brand-secondary-10', color: 'brand-secondary-120' }
      case 'insight':
        return {
          backColor: 'utility-attention-10',
          color: 'utility-attention-120',
        }
      case 'competitions':
        return { backColor: 'extra-pink-10', color: 'extra-pink-120' }
      default:
        return { backColor: 'brand-primary-10', color: 'brand-primary-120' }
    }
  }

  if (!list?.length) {
    return null
  }

  return (
    <div>
      {list.map((category) => {
        return (
          <TagComponent
            key={`category-${category.slug}`}
            {...getColors(category.slug)}
          >
            {category.title}
          </TagComponent>
        )
      })}
    </div>
  )
}

Categories.propTypes = {
  list: array,
}

export default Categories
